
if(!customElements.get('sensic-mic-table')){customElements.define('sensic-mic-table',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.body=this.querySelector('[data-table-body]');this.rows=[...this.querySelectorAll('[data-mic-row]')];this.search=this.querySelector('[data-search]');this.brand=this.querySelector('[data-brand]');this.sort=this.querySelector('[data-sort]');this.more=this.querySelector('[data-more]');this.pageSize=window.matchMedia('(max-width:899px)').matches?10:12;this.limit=this.pageSize;this.search.addEventListener('input',()=>{this.limit=this.pageSize;this.update()});this.brand.addEventListener('change',()=>{this.limit=this.pageSize;this.update()});this.sort.addEventListener('change',()=>{this.limit=this.pageSize;this.sortRows();this.update()});this.more.addEventListener('click',()=>{this.limit+=this.pageSize;this.update()});this.sortRows();this.update()}
normal(text){return text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ø/g,'o').replace(/[^a-z0-9+]/g,'')}
sortRows(){const alpha=(a,b)=>a.dataset.brandName.localeCompare(b.dataset.brandName,undefined,{sensitivity:'base'})||a.dataset.model.localeCompare(b.dataset.model,undefined,{numeric:true,sensitivity:'base'});this.rows.sort((a,b)=>this.sort.value==='alphabetical'?alpha(a,b):(Number(a.dataset.popularity)-Number(b.dataset.popularity)||alpha(a,b)));this.rows.forEach(row=>this.body.append(row))}
update(){const query=this.normal(this.search.value),brand=this.brand.value;let count=0;this.rows.forEach(row=>{const match=(!brand||row.dataset.brandName===brand)&&this.normal(row.dataset.brandName+' '+row.dataset.model).includes(query);if(match)count++;row.hidden=!match||count>this.limit});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-empty]').hidden=count>0;this.more.hidden=count<=this.limit;this.querySelector('.smt-table-wrap').hidden=count===0}
})}

if (!customElements.get('sensic-manual-compatibility')) {
  customElements.define('sensic-manual-compatibility', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.closest('details');
      this.onToggle = () => { if (this.details.open) this.load(); };
      this.details.addEventListener('toggle', this.onToggle);
      if (this.details.open) this.load();
    }
    disconnectedCallback() { this.details?.removeEventListener('toggle', this.onToggle); this.ready = false; }
    async load() {
      if (this.loaded || this.loading) return;
      this.loading = true;
      const status = this.querySelector('[data-status]');
      status.textContent = this.dataset.loading;
      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Compatibility page unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const table = document.querySelector('sensic-mic-table');
        if (!table?.querySelector('[data-mic-row]')) throw new Error('Compatibility table unavailable');
        const sourceUrl = new URL(this.dataset.url, window.location.origin);
        const originalPath = sourceUrl.pathname.replace(/^\/(nl|de)\//, '/');
        if (originalPath !== sourceUrl.pathname) {
          const originalResponse = await fetch(originalPath, { credentials: 'same-origin' });
          if (!originalResponse.ok) throw new Error('Original microphone names unavailable');
          const originalDocument = new DOMParser().parseFromString(await originalResponse.text(), 'text/html');
          const originalTable = originalDocument.querySelector('sensic-mic-table');
          if (!originalTable) throw new Error('Original microphone table unavailable');
          const identities = new Map([...originalTable.querySelectorAll('[data-mic-row]')].map(row => [row.querySelector('.smt-mic-image img')?.getAttribute('src'), row]));
          table.querySelectorAll('[data-mic-row]').forEach(row => {
            const original = identities.get(row.querySelector('.smt-mic-image img')?.getAttribute('src'));
            if (!original) return;
            row.dataset.brandName = original.dataset.brandName;
            row.dataset.model = original.dataset.model;
            row.querySelector('.smt-brand__name').textContent = original.dataset.brandName;
            row.querySelector('.smt-name strong').textContent = original.dataset.model;
          });
          const originalOptions = [...originalTable.querySelectorAll('[data-brand] option')];
          table.querySelectorAll('[data-brand] option').forEach((option, index) => {
            if (!index || !originalOptions[index]) return;
            option.value = originalOptions[index].value;
            option.textContent = originalOptions[index].textContent;
          });
        }
        table.querySelectorAll('.smt-hero,.smt-shop,.smt-help').forEach(element => element.remove());
        table.id = `ManualMicTable-${this.closest('section').id}`;
        this.querySelector('[data-table]').append(table);
        status.textContent = '';
        status.hidden = true;
        this.loaded = true;
      } catch (error) {
        status.textContent = this.dataset.error;
        this.querySelector('[data-fallback]').hidden = false;
      } finally { this.loading = false; }
    }
  });
}
